import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const WaiterGameContext = createContext(null);

export function WaiterGameProvider({ children }) {
  const [isInviteOpen, setIsInviteOpen] = useState(false);
  const [lastOrderMeta, setLastOrderMeta] = useState(null);

  const openInvite = useCallback((meta = null) => {
    setLastOrderMeta(meta);
    setIsInviteOpen(true);
  }, []);

  const closeInvite = useCallback(() => setIsInviteOpen(false), []);

  const value = useMemo(
    () => ({
      isInviteOpen,
      lastOrderMeta,
      openInvite,
      closeInvite,
    }),
    [isInviteOpen, lastOrderMeta, openInvite, closeInvite]
  );

  return <WaiterGameContext.Provider value={value}>{children}</WaiterGameContext.Provider>;
}

export function useWaiterGame() {
  const ctx = useContext(WaiterGameContext);
  if (!ctx) throw new Error('useWaiterGame must be used within a WaiterGameProvider');
  return ctx;
}
